<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DO0Gnu/tc-custom/9781466806276.jpg?1725038474226" alt="This image is the cover for the book Varieties of Disturbance"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Varieties of Disturbance
      </h1>
      <p class="bookDescription body article font2">
        <p>Lydia Davis has been called "one of the quiet giants in the world of American fiction" (<i>Los Angeles Times</i>), "an American virtuoso of the short story form" (<i>Salon</i>), an innovator who attempts "to remake the model of the modern short story" (<i>The New York Times Book Review</i>). Her admirers include Grace Paley, Jonathan Franzen, and Zadie Smith; as <i>Time </i>magazine observed, her stories are "moving . . . and somehow inevitable, as if she has written what we were all on the verge of thinking."<br/><br/>In <i>Varieties of Disturbance</i>, her fourth collection, Davis extends her reach as never before in stories that take every form from sociological studies to concise poems. Her subjects include the five senses, fourth-graders, good taste, and tropical storms. She offers a reinterpretation of insomnia and re-creates the ordeals of Kafka in the kitchen. She questions the lengths to which one should go to save the life of a caterpillar, proposes a clear account of the sexual act, rides the bus, probes the limits of marital fidelity, and unlocks the secret to a long and happy life.<br/><br/>No two of these fictions are alike. And yet in each, Davis rearranges our view of the world by looking beyond our preconceptions to a bizarre truth, a source of delight and surprise.<br/><br/><i>Varieties of Disturbance</i> is a 2007 National Book Award Finalist for Fiction.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lydia Davis
      </h2>
      
      <p class="authorDescription body article"><P><B>Lydia Davis</B>'s story collections include the <I>Village Voice </I>favorite <I>Samuel Johnson Is Indignant </I>and <I>Almost No Memory</I>, a <I>Los Angeles Times </I>Best Book of the Year. She is the acclaimed translator of the new <I>Swann's Way. </I>She received a 2003 MacArthur fellowship.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux New York
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?523ed4c2